import { Component, HostListener, Input, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Feature } from 'ol';
import { CoordinatePointModel } from 'src/app/models/coordinate-point';
import { Route } from 'src/app/models/Route';
import { Segment } from 'src/app/models/Segment';
import { PointsService } from 'src/app/services/points.service';
import * as olProj from 'ol/proj';
import { rotate } from 'ol/transform';
import { ProcedureCoordinatePointModel } from 'src/app/models/procedure-coordinate-point';
import { ProcedureControlService } from 'src/app/services/procedure-control.service';
import { SelectCoordinatePointsControlService } from '../services/select-coordinate-points-control.service';
import { ProcedureModel } from 'src/app/models/procedure';
import { UtilsService } from 'src/app/services/utils.service';
import { GlobalSelectionControlService } from 'src/app/map/services/global-selection-control.service';
import { ModalControlService } from 'src/app/services/modal-control.service';
import { CoordinatePointsService } from 'src/app/services/coordinate-points.service';
import { TabsService } from 'src/app/services/tabsService';
import { v4 as uuidv4 } from 'uuid';

@Component({
  selector: 'app-create-procedure-from-route-segment',
  templateUrl: './create-procedure-from-route-segment.component.html',
  styleUrls: ['../../app.component.scss'],
  standalone: false
})
export class CreateProcedureFromRouteSegmentComponent implements OnInit {

  @Input() routeSegments: Map<string, Route>;
  procedureCoordPointElevation: string;

  constructor(private bsModalRef: BsModalRef,
    private pointsController: PointsService,
    private procedureController: ProcedureControlService,
    private selectProcedureService: SelectCoordinatePointsControlService,
    private globalSelectionService: GlobalSelectionControlService,
    private modalService: ModalControlService,
    public coordinatePointsService: CoordinatePointsService,
    public tabsService: TabsService
  ) {
    this.routeSegments = new Map();
    this.procedureCoordPointElevation = '0';
  }

  ngOnInit(): void {

  }

  selectRouteRow(route: Route): void {
    this.routeSegments.forEach((value: Route, key: string) => {
      if (route.designation == key) {
        value.isSelected = true;
      } else {
        value.isSelected = false;
      }
    });
  }

  createProcedureFromRouteSegment(): void {
    let selectedRows: number = 0;
    let procedureCoordinatePoints: ProcedureCoordinatePointModel[] = [];
    let sequencenumber: number = 0;
    this.routeSegments.forEach((value: Route, key: string) => {
      if (value.isSelected) {
        ++selectedRows;
        value.segments.forEach(segment => {
          let newStartProcedureCoordinatePoint: ProcedureCoordinatePointModel = new ProcedureCoordinatePointModel();
          if (!segment.startpoint.uuid) {
            segment.startpoint.uuid = uuidv4();
          }
          newStartProcedureCoordinatePoint.coordPoint = segment.startpoint;
          newStartProcedureCoordinatePoint.sequencenumber = sequencenumber;
          newStartProcedureCoordinatePoint.altitude = this.calculateProcedureCoordinatePointAltitude(segment);
          //this.globalSelectionService.setSelectedCoordinatePointModel(newStartProcedureCoordinatePoint.coordPoint);
          //this.pointsController.deleteCoordinatePoint

          if (!this.checkIfProcedureCoordinatePointAlreadyExist(newStartProcedureCoordinatePoint, procedureCoordinatePoints)) {
            this.pointsController.addCoordinatePointToMap(newStartProcedureCoordinatePoint.coordPoint);
            procedureCoordinatePoints.push(newStartProcedureCoordinatePoint);
          }

          let newEndProcedureCoordinatePoint: ProcedureCoordinatePointModel = new ProcedureCoordinatePointModel();
          if (!segment.endpoint.uuid) {
            segment.endpoint.uuid = uuidv4();
          }
          newEndProcedureCoordinatePoint.coordPoint = segment.endpoint;
          newEndProcedureCoordinatePoint.sequencenumber = sequencenumber + 1;
          newEndProcedureCoordinatePoint.altitude = this.calculateProcedureCoordinatePointAltitude(segment);
          //this.globalSelectionService.setSelectedCoordinatePointModel(newEndProcedureCoordinatePoint.coordPoint);

          if (!this.checkIfProcedureCoordinatePointAlreadyExist(newEndProcedureCoordinatePoint, procedureCoordinatePoints)) {
            this.pointsController.addCoordinatePointToMap(newEndProcedureCoordinatePoint.coordPoint);
            procedureCoordinatePoints.push(newEndProcedureCoordinatePoint);
          }
          sequencenumber++;
        });
      }
    });

    if (selectedRows > 0) {
      let newProcedure: ProcedureModel = new ProcedureModel();
      newProcedure.procedureCoordinatePoints = procedureCoordinatePoints;
      newProcedure.procedureLegs = this.procedureController.createProcedureLegsFromProcedure(newProcedure, this.procedureController.createProcedureIDCount + 1);
      this.tabsService.saveCurrentTab(); // important that this comes before the following two lines
      this.selectProcedureService.selectedProcedure = newProcedure;
      this.tabsService.openNewCreateTab(TabsService.CREATE_PROCEDURE_FROM_ROUTE, newProcedure);

      //this.procedureController.activateCreateProcedureWindow();
      //this.globalSelectionService.clearAllSelectedExceptRouteSegment();
      this.bsModalRef.hide();
    } else {
      this.modalService.showMesssageModal("Create Procedure from Route Segments", "Select at least one row of the table.");
    }

  }

  checkIfProcedureCoordinatePointAlreadyExist(point: ProcedureCoordinatePointModel, list: ProcedureCoordinatePointModel[]): boolean {
    let toReturn: boolean = false;
    list.forEach(elm => {
      if (point.coordPoint.coordpointid == elm.coordPoint.coordpointid
        && point.coordPoint.name == elm.coordPoint.name
        && point.coordPoint.latitude == elm.coordPoint.latitude
        && point.coordPoint.longitude == elm.coordPoint.longitude) {
        toReturn = true;
      }
    });
    return toReturn;
  }

  calculateProcedureCoordinatePointAltitude(segment: Segment): number {
    let altitudeToReturn: number = 0;

    if (segment.upperVerticalDistance == null && segment.lowerVerticalDistance == null) {
      return altitudeToReturn = 0;
    }

    switch (this.procedureCoordPointElevation) {
      case "0":
        altitudeToReturn = (segment.upperVerticalDistance + segment.lowerVerticalDistance) / 2;
        break;
      case "1":
        altitudeToReturn = segment.upperVerticalDistance;
        break;
      case "2":
        altitudeToReturn = segment.lowerVerticalDistance;
        break;
    }
    return altitudeToReturn;
  }

  @HostListener('document:keydown.escape', ['$event'])
  onEscape(event: KeyboardEvent) {
    this.cancel(false); // escape key already hides the modal
  }

  cancel(hideModal: boolean = true): void {
    hideModal ? this.bsModalRef.hide() : false;
    this.pointsController.deleteCoordinatePointsFromMap();
    this.pointsController.fetchAndAddCoordinatePoints();
  }

}
